export default "__VITE_ASSET__DyuhsWi___"